import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getUserDetails, userList, debtList } from "../../api/user";

const initialState = {
  list: [],
  total: 0,
};

export const UserSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    lists: (state, action) => {
      state.list = action.payload;
    },
    totalCount: (state, action) => {
      state.total = action.payload;
    },
    details: (state, action) => {
      state.detail = action.payload;
    },
    debtLists: (state, action) => {
      state.debt_list = action.payload;
    },
    debtCount: (state, action) => {
      state.debt_total = action.payload;
    },
  },
});

export const { lists, totalCount, details, debtLists, debtCount } = UserSlice.actions;

export const userListSelector = (state) => state.user.list;
export const totalUserCountSelector = (state) => state.user.total;

export const debtListSelector = (state) => state.user.debt_list;
export const debtCountSelector = (state) => state.user.debt_total;

export const FetchUserList = createAsyncThunk(
  "FetchUserList",
  async (obj, { dispatch }) => {
    try {
      const response = await userList(obj);
      if (response?.code === 1) {
        dispatch(lists(response?.data?.user_list));
        dispatch(totalCount(response?.data?.total_user));
      }

      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const userDetailSelector = (state) => state.user.detail;

export const FetchUserDetail = createAsyncThunk(
  "FetchUserDetail",
  async (obj, { dispatch }) => {
    try {
      const response = await getUserDetails(obj);
      if (response?.code === 1) {
        dispatch(details(response?.data?.user_details));
      }

      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchDebtList = createAsyncThunk(
  "FetchDebtList",
  async (obj, { dispatch }) => {
    try {
      const response = await debtList(obj);
      if (response?.code === 1) {
        dispatch(debtLists(response?.data?.debt_list));
        dispatch(debtCount(response?.data?.debt_list?.length || 0));
      }

      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export default UserSlice.reducer;
